import { css } from '@emotion/react'

import useClientInfo from '../services/useClientInfo'
import Colors from '../theme/Colors'
import Notification from './Notification'

export default function Section(props: {
  id?: string
  title?: React.ReactNode
  notification?: React.ReactElement<typeof Notification> | null
  children: React.ReactNode
  leftToRight?: boolean
  className?: string
  noPadding?: boolean
}) {
  const clientInfo = useClientInfo()
  const leftToRight = clientInfo.isMobile() ? false : props.leftToRight
  return (
    <section
      className={props.className}
      aria-labelledby={props.id}
      css={css`
        position: relative;
        border-radius: 5px;
        box-shadow: 0 0 6px 0 ${Colors.Gray100};
        background: white;
        padding: ${props.noPadding ? 0 : '20px'};
        color: ${Colors.Gray600};
        box-sizing: border-box;
      `}
    >
      {props.notification}

      <div
        css={
          leftToRight &&
          css`
            display: flex;
          `
        }
      >
        {props.title && (
          <h2
            id={props.id}
            css={[
              css`
                font-size: 18px;
                font-weight: 600;
                line-height: 1;
                margin: 0 0 20px 0;
              `,
              leftToRight &&
                css`
                  font-size: 16px;
                  width: 190px;
                  margin: 0 10px 0 0;
                `,
            ]}
          >
            {props.title}
          </h2>
        )}

        <div
          css={
            leftToRight &&
            css`
              flex: 1;
            `
          }
        >
          {props.children}
        </div>
      </div>
    </section>
  )
}
